import { translate } from 'infras/i18n';
import { useRouter } from 'next/router';
import { FeatureItem } from 'presentations/api/schema/contents';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import {
  featureListPath,
  featurePath,
  webPath,
} from 'presentations/routes/path';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import { useContext, useEffect, useMemo } from 'react';
import { setEvent } from 'presentations/views/helpers/analytics';

export interface Props {
  feature: FeatureItem;
}

export const useFeaturePage = (props: Props) => {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  useEffect(() => {
    if (!serviceState.isInitialized) {
      return;
    }
    setEvent('read feature post', {
      slug: props.feature.slug,
      title: props.feature.name,
    });
  }, [serviceState.isInitialized, props.feature.id]);

  const breadcrumbs = [];
  breadcrumbs.push({
    title: translate('breadcrumbs.Features'),
    link: featureListPath(),
  });
  breadcrumbs.push({
    title: props.feature.name,
    link: featurePath(props.feature.slug),
  });
  const routes = setBreadcrumbs(breadcrumbs);

  const router = useRouter();
  const shareUrl = webPath(featurePath(props.feature.slug), router.locale);

  return {
    state: {
      viewer,
      routes,
      shareUrl,
    },
    actions: {},
  };
};
